import React from 'react';
import Input from '../../../../../../components/Input/Input';
import './DetailRequest.css';
import { useLocation } from 'react-router-dom';

const DetailRequest = () => {
  const { request } = useLocation().state;

  return (
    <div className="detail-request-page">
      <div className="detail-request-container">
        <div className="title-container">
          <h1 className="page-title">
            View <span className="highlight">customer</span>
          </h1>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Request Folio</label>
            <Input
              type="text"
              value={request?.id || ''}
              disabled={true}
            />
          </div>
          <div className="form-group">
            <label>Category</label>
            <Input
              type="text"
              value={request?.category || ''}
              disabled={true}
            />
          </div>
          <div className="form-group">
            <label>Subcategory</label>
            <Input
              type="text"
              value={request?.subcategory || ''}
              disabled={true}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Type of service</label>
            <Input
              type="text"
              value={request?.typeOfService || ''}
              disabled={true}
            />
          </div>
          <div className="form-group">
            <label>Date</label>
            <Input
              type="text"
              value={request?.date || ''}
              disabled={true}  
            />
          </div>
          <div className="form-group">
            <label>Time</label>
            <Input
              type="text"
              value={request?.time || ''}
              disabled={true}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Number of tokens used</label>
            <Input
              type="text"
              value={request?.tokensUsed || ''}
              disabled={true}
            />
          </div>
          <div className="form-group">
            <label>Status</label>
            <Input
              type="text"
              value={request?.status || ''}
              disabled={true}
            />
          </div>
          <div className="form-group" />
        </div>
      </div>
    </div>
  );
};

export default DetailRequest;
